<template>
  <el-dropdown-item
    v-if="text"
    class="app-header-global-search__dropdown_empty no-hover"
  >
    <p>{{ text }}</p>
  </el-dropdown-item>
</template>


<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'DdGlobalSearchEmpty',

  props: {
    /**
     * Activate search
     */
    text: {
      type: String,
      default: null,
    },
  },
})
</script>

<style lang="scss">
.el-dropdown-menu.app-header-global-search__dropdown_empty {
  background-color: var(--color-background-header);
}

.app-header-global-search__dropdown {
  &_empty {
    overflow: hidden;
    text-align: center;

    p {
      margin: 10px 0;
      @include lettering--p;
      color: var(--color-text-primary);
    }
  }
}
</style>
